"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScrollToFormLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _button = require("@design/ui/button");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var SCROLL_TO_FORM_LABEL = "↑ View form";
var ScrollToFormLink = exports.ScrollToFormLink = function ScrollToFormLink(_ref) {
  var formId = _ref.formId;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
    type: "button",
    variant: "link",
    size: "xs",
    onClick: function onClick() {
      var _document$getElementB;
      return (_document$getElementB = document.getElementById(formId)) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });
    },
    className: "mt-1",
    "data-sentry-element": "Button",
    "data-sentry-component": "ScrollToFormLink",
    "data-sentry-source-file": "ScrollToFormLink.tsx",
    children: SCROLL_TO_FORM_LABEL
  });
};